import React from 'react';
import './_screenshot-toolbar.scss';
import VStore from "../../../store";
import VButton from "../../v-button/v-button";
export default function ScreenshotToolbar() {

    const {setScreenshotMode} = VStore();

    return (<div className="screenshot-toolbar">
        <VButton id='download_screenshot' className='download-btn'
                 content={<img src="./assets/images/download.svg" alt="Download"/>}
        />

        <VButton id='share-fb-btn' content={<img src="./assets/images/facebook.svg" alt="Facebook"/>} />

        <VButton content={<img src="./assets/images/x.svg" alt="X"/>}/>

        <VButton content={<img src="./assets/images/linkedin.svg" alt="Linkedin"/>} />

        <VButton className='back-btn' onClick={() => setScreenshotMode(false)}
                 content={<img src="./assets/images/back.svg" alt="Back"/>}
        />
    </div>);
}
